/**
 * This file didn't exist anywhere — I imported `resolveImageUrl` from it in
 * Coupons/CouponsDetails/index.js without ever building it or flagging the
 * assumption, which was a mistake on my part. Worth noting: every other
 * screen that renders a coupon image (ReserveCoupon/ReservedCoupon.js,
 * components/UsedCoupon/UsedCoupon.js) uses the raw `image_url` value
 * directly as an <img> src with no cleanup step at all — so this wrapper
 * was never a real, established pattern in the rest of the conversion, just
 * something I introduced inconsistently in this one file.
 *
 * Built now as a real, minimal utility rather than just deleting the
 * import, since normalizing external image URLs is still a reasonable
 * thing to centralize: handles protocol-relative URLs (`//cdn.example.com/x.jpg`,
 * which the original mobile app's RN <Image> component tolerates but a
 * plain web <img src> may not resolve consistently depending on the page's
 * own scheme), trims stray whitespace, and passes through anything else
 * unchanged. If your backend has a different, more specific normalization
 * need (e.g. swapping a legacy CDN domain, signing URLs, etc.), extend this
 * function — the call site (CouponsDetails) doesn't need to change.
 */

export const resolveImageUrl = url => {
  if (!url || typeof url !== 'string') return null;

  const trimmed = url.trim();
  if (!trimmed) return null;

  // Protocol-relative URL ("//cdn.example.com/x.jpg") — prefix with https:
  // so it resolves correctly regardless of how it's embedded.
  if (trimmed.startsWith('//')) {
    return `https:${trimmed}`;
  }

  return trimmed;
};

export default resolveImageUrl;